import script from "./json-box.vue?vue&type=script&lang=js"
export * from "./json-box.vue?vue&type=script&lang=js"

import "./json-box.vue?vue&type=style&index=0&id=65743dfc&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/extra/VabJsonViewer/json-box.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65743dfc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65743dfc', __exports__)) {
    console.log('reload')
    api.reload('65743dfc', __exports__)
  }
  
}


export default __exports__